import Icon from '../components/Icon.vue'

Icon.register({
  bong: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M302.5 512C325.7 512 346.9 499.4 358.5 479.3 374.7 451.3 384 418.8 384 384 384 347.9 373.9 314.2 356.6 285.4L400 241.9 409.4 251.3C415.6 257.6 425.8 257.6 432 251.3L443.3 240C449.6 233.8 449.6 223.6 443.3 217.4L390.6 164.7C384.4 158.4 374.2 158.4 368 164.7L356.7 176C350.4 182.2 350.4 192.4 356.7 198.6L366.1 208 326.6 247.4C315.1 236 302.1 226.1 288 217.9V63.7L304 63.7C312.8 63.7 319.9 56.6 320 47.7L320 16C320 7.2 312.8 0 304 0L80 0.3C71.2 0.3 64.1 7.4 64 16.2L64 48C64 56.8 71.2 64 80 64L96 64V217.9C38.7 251.1 0 313 0 384 0 418.8 9.3 451.3 25.5 479.3 37.1 499.4 58.3 512 81.5 512H302.5zM120.1 259.4L144 245.6V63.9L240 63.8V245.6L263.9 259.4C288.8 273.8 308.1 295.2 320.5 320H63.5C76 295.2 95.3 273.8 120.1 259.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bong.js
// module id = X1l6
// module chunks = 144